<span class="activity-color" [ngClass]="activityColorCssClass">{{ label }}</span>
